module.exports = __webpack_public_path__ + "static/img/newStock4.9989cfc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/works/newStock/newStock4.jpg
// module id = CGsw
// module chunks = 1